var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.menu.MenuLink},scopedSlots:_vm._u([{key:"default",fn:function({ href, navigate, isActive, isExactActive }){return [_c('li',{staticClass:"menu-item",class:[
      isActive && 'menu-item-active',
      isExactActive && 'menu-item-active',
    ],attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('a',{staticClass:"menu-link",attrs:{"href":href},on:{"click":navigate}},[_c('i',{staticClass:"menu-icon",class:_vm.menu.MenuIcon,style:(_vm.menu.MenuStyle)}),_c('span',{staticClass:"menu-text"},[_vm._v(" "+_vm._s(_vm.menu.MenuText)+" ")])])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }